"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.setProjectName = exports.setApiBaseUrl = exports.globals = void 0;
var package_json_1 = __importDefault(require("../package.json"));
var globals = {
    apiBaseUrl: "https://api.guild.xyz/v1",
    headers: { "User-Agent": "@guildxyz/sdk:".concat(package_json_1.default === null || package_json_1.default === void 0 ? void 0 : package_json_1.default.version), "Project-Name": "", "Content-Type": "application/json" },
};
exports.globals = globals;
var setApiBaseUrl = function (apiBaseUrl) {
    globals.apiBaseUrl = apiBaseUrl;
};
exports.setApiBaseUrl = setApiBaseUrl;
var setProjectName = function (projectName) {
    globals.headers["Project-Name"] = projectName;
};
exports.setProjectName = setProjectName;
